// 开票相关页面

// const InfoFullfill = r => require.ensure(
//   [],
//   () => r(require('@/components/apply-about/info-fullfill')),
//   'InfoFullfill'
// )
const InfoFullfill = r => require.ensure(
  [],
  () => r(require('@/components/apply-about/index')),
  'InfoFullfill'
)
const UserCenter = r => require.ensure(
  [],
  () => r(require('@/components/bloom-user/panel')),
  'UserCenter'
)
const MoreInformation = r => require.ensure(
  [],
  () => r(require('@/components/bloom-user/personal-center/moreInformation')),
  'MoreInformation'
)
const Signature = r => require.ensure(
  [],
  () => r(require('@/components/bloom-user/personal-center/signature')),
  'Signature'
)
const Material = r => require.ensure(
  [],
  () => r(require('@/components/bloom-user/personal-center/material')),
  'Material'
)
const AdmissionTicket = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/admissionTicket/AdmissionTicket')),
  'Material'
)
export default [
  {
    path: '/InfoFullfill',
    name: 'InfoFullfill',
    component: InfoFullfill
  },
  {
    path: '/UserCenter',
    name: 'UserCenter',
    component: UserCenter
  },
  {
    path: '/Material',
    name: 'Material',
    component: Material
  },
  {
    path: '/MoreInformation',
    name: 'MoreInformation',
    component: MoreInformation
  },
  {
    path: '/Signature',
    name: 'Signature',
    component: Signature
  },
  {
    path: '/AdmissionTicket',
    name: 'AdmissionTicket',
    component: AdmissionTicket
  }

]



// WEBPACK FOOTER //
// ./src/router/sub-route/apply-about.js